(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-odour-defense"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var STEP = 2;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function setPosition(root, percent) {
      percent = clamp(percent, 0, 100);
      var beforeWrap = root.querySelector('[data-hod-before-wrap]');
      var handle = root.querySelector('[data-hod-handle]');
      var stage = root.querySelector('.hod-compare__stage');

      if (beforeWrap) {
        beforeWrap.style.width = percent + '%';
        var img = beforeWrap.querySelector('img');
        if (img && stage) {
          img.style.width = stage.getBoundingClientRect().width + 'px';
        }
      }
      if (handle) {
        handle.style.left = percent + '%';
        handle.setAttribute('aria-valuenow', Math.round(percent));
      }
    }

    function percentFromEvent(stage, clientX) {
      var rect = stage.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function initCompare(root) {
      var stage = root.querySelector('.hod-compare__stage');
      var handle = root.querySelector('[data-hod-handle]');
      if (!stage || !handle) return;

      var initial = parseFloat(root.getAttribute('data-initial-position'));
      if (isNaN(initial)) initial = 50;

      var dragging = false;

      stage.addEventListener('pointerdown', function (event) {
        dragging = true;
        if (stage.setPointerCapture && event.pointerId != null) {
          stage.setPointerCapture(event.pointerId);
        }
        setPosition(root, percentFromEvent(stage, event.clientX));
        event.preventDefault();
      });

      window.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        setPosition(root, percentFromEvent(stage, event.clientX));
      });

      window.addEventListener('pointerup', function () { dragging = false; });
      window.addEventListener('pointercancel', function () { dragging = false; });

      handle.addEventListener('keydown', function (event) {
        var current = parseFloat(handle.getAttribute('aria-valuenow')) || initial;
        if (event.key === 'ArrowLeft') {
          setPosition(root, current - STEP);
          event.preventDefault();
        } else if (event.key === 'ArrowRight') {
          setPosition(root, current + STEP);
          event.preventDefault();
        } else if (event.key === 'Home') {
          setPosition(root, 0);
          event.preventDefault();
        } else if (event.key === 'End') {
          setPosition(root, 100);
          event.preventDefault();
        }
      });

      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          var current = parseFloat(handle.getAttribute('aria-valuenow')) || initial;
          setPosition(root, current);
        }).observe(stage);
      } else {
        window.addEventListener('resize', function () {
          var current = parseFloat(handle.getAttribute('aria-valuenow')) || initial;
          setPosition(root, current);
        });
      }

      setPosition(root, initial);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-hod-compare]').forEach(function (root) {
        if (root.dataset.hodInitialized) return;
        root.dataset.hodInitialized = 'true';
        initCompare(root);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["odour-defense-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initCarousel(section) {
      var track = section.querySelector('[data-lbc-track]');
      var prevBtn = section.querySelector('[data-lbc-prev]');
      var nextBtn = section.querySelector('[data-lbc-next]');
      if (!track) return;

      function scrollByAmount(direction) {
        var item = track.querySelector('.loved-by-customers__item');
        if (!item) return;
        var itemWidth = item.getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap || 0);
        track.scrollBy({ left: direction * (itemWidth + gap), behavior: 'smooth' });
      }

      function updateNavState() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () { scrollByAmount(-1); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () { scrollByAmount(1); });
      }

      track.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      updateNavState();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.loved-by-customers').forEach(function (section) {
        if (section.dataset.lbcInitialized) return;
        section.dataset.lbcInitialized = 'true';
        initCarousel(section);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-white-before-after"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var STEP = 2;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function setPosition(root, percent) {
      percent = clamp(percent, 0, 100);
      var beforeWrap = root.querySelector('[data-rr-before-wrap]');
      var handle = root.querySelector('[data-rr-handle]');

      if (beforeWrap) {
        beforeWrap.style.width = percent + '%';
        var img = beforeWrap.querySelector('img, .rr-compare__placeholder-svg');
        var stage = root.querySelector('.rr-compare__stage');
        if (img && stage) {
          var stageWidth = stage.getBoundingClientRect().width;
          img.style.width = stageWidth + 'px';
        }
      }
      if (handle) {
        handle.style.left = percent + '%';
        handle.setAttribute('aria-valuenow', Math.round(percent));
      }
    }

    function percentFromEvent(stage, clientX) {
      var rect = stage.getBoundingClientRect();
      var x = clientX - rect.left;
      return (x / rect.width) * 100;
    }

    function initCompare(root) {
      var stage = root.querySelector('.rr-compare__stage');
      var handle = root.querySelector('[data-rr-handle]');
      if (!stage || !handle) return;

      var initial = parseFloat(root.getAttribute('data-initial-position'));
      if (isNaN(initial)) initial = 50;

      var dragging = false;

      function onPointerDown(event) {
        dragging = true;
        if (stage.setPointerCapture && event.pointerId != null) {
          stage.setPointerCapture(event.pointerId);
        }
        setPosition(root, percentFromEvent(stage, event.clientX));
        event.preventDefault();
      }

      function onPointerMove(event) {
        if (!dragging) return;
        setPosition(root, percentFromEvent(stage, event.clientX));
      }

      function onPointerUp() {
        dragging = false;
      }

      stage.addEventListener('pointerdown', onPointerDown);
      window.addEventListener('pointermove', onPointerMove);
      window.addEventListener('pointerup', onPointerUp);
      window.addEventListener('pointercancel', onPointerUp);

      handle.addEventListener('keydown', function (event) {
        var current = parseFloat(handle.getAttribute('aria-valuenow')) || initial;
        if (event.key === 'ArrowLeft') {
          setPosition(root, current - STEP);
          event.preventDefault();
        } else if (event.key === 'ArrowRight') {
          setPosition(root, current + STEP);
          event.preventDefault();
        } else if (event.key === 'Home') {
          setPosition(root, 0);
          event.preventDefault();
        } else if (event.key === 'End') {
          setPosition(root, 100);
          event.preventDefault();
        }
      });

      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          var current = parseFloat(handle.getAttribute('aria-valuenow')) || initial;
          setPosition(root, current);
        }).observe(stage);
      } else {
        window.addEventListener('resize', function () {
          var current = parseFloat(handle.getAttribute('aria-valuenow')) || initial;
          setPosition(root, current);
        });
      }

      setPosition(root, initial);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-rr-compare]').forEach(function (root) {
        if (root.dataset.rrInitialized) return;
        root.dataset.rrInitialized = 'true';
        initCompare(root);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
    document.addEventListener('shopify:block:select', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-white-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var STEP = 2;

    function clamp(value, min, max) {
      return Math.max(min, Math.min(max, value));
    }

    function setPosition(root, percent) {
      percent = clamp(percent, 0, 100);
      var beforeWrap = root.querySelector('[data-hbw-before-wrap]');
      var handle = root.querySelector('[data-hbw-handle]');
      var stage = root.querySelector('.hbw-compare__stage');

      if (beforeWrap) {
        beforeWrap.style.width = percent + '%';
        var img = beforeWrap.querySelector('img');
        if (img && stage) {
          img.style.width = stage.getBoundingClientRect().width + 'px';
        }
      }
      if (handle) {
        handle.style.left = percent + '%';
        handle.setAttribute('aria-valuenow', Math.round(percent));
      }
    }

    function percentFromEvent(stage, clientX) {
      var rect = stage.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function initCompare(root) {
      var stage = root.querySelector('.hbw-compare__stage');
      var handle = root.querySelector('[data-hbw-handle]');
      if (!stage || !handle) return;

      var initial = parseFloat(root.getAttribute('data-initial-position'));
      if (isNaN(initial)) initial = 50;

      var dragging = false;

      stage.addEventListener('pointerdown', function (event) {
        dragging = true;
        if (stage.setPointerCapture && event.pointerId != null) {
          stage.setPointerCapture(event.pointerId);
        }
        setPosition(root, percentFromEvent(stage, event.clientX));
        event.preventDefault();
      });

      window.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        setPosition(root, percentFromEvent(stage, event.clientX));
      });

      window.addEventListener('pointerup', function () { dragging = false; });
      window.addEventListener('pointercancel', function () { dragging = false; });

      handle.addEventListener('keydown', function (event) {
        var current = parseFloat(handle.getAttribute('aria-valuenow')) || initial;
        if (event.key === 'ArrowLeft') {
          setPosition(root, current - STEP);
          event.preventDefault();
        } else if (event.key === 'ArrowRight') {
          setPosition(root, current + STEP);
          event.preventDefault();
        } else if (event.key === 'Home') {
          setPosition(root, 0);
          event.preventDefault();
        } else if (event.key === 'End') {
          setPosition(root, 100);
          event.preventDefault();
        }
      });

      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          var current = parseFloat(handle.getAttribute('aria-valuenow')) || initial;
          setPosition(root, current);
        }).observe(stage);
      } else {
        window.addEventListener('resize', function () {
          var current = parseFloat(handle.getAttribute('aria-valuenow')) || initial;
          setPosition(root, current);
        });
      }

      setPosition(root, initial);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-hbw-compare]').forEach(function (root) {
        if (root.dataset.hbwInitialized) return;
        root.dataset.hbwInitialized = 'true';
        initCompare(root);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["super-white-video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initCarousel(section) {
      var track = section.querySelector('[data-vtc-track]');
      var prevBtn = section.querySelector('[data-vtc-prev]');
      var nextBtn = section.querySelector('[data-vtc-next]');
      if (!track) return;

      function scrollByAmount(direction) {
        var item = track.querySelector('.video-testimonials__item');
        if (!item) return;
        var itemWidth = item.getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap || 0);
        track.scrollBy({ left: direction * (itemWidth + gap), behavior: 'smooth' });
      }

      function updateNavState() {
        if (!prevBtn || !nextBtn) return;
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= maxScroll;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () { scrollByAmount(-1); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () { scrollByAmount(1); });
      }

      track.addEventListener('scroll', updateNavState, { passive: true });
      window.addEventListener('resize', updateNavState);
      updateNavState();
    }

    function initPlayButtons(section) {
      section.querySelectorAll('[data-vtc-media]').forEach(function (media) {
        var playBtn  = media.querySelector('[data-vtc-play]');
        var pauseBtn = media.querySelector('[data-vtc-pause]');
        var video    = media.querySelector('.vtc-video');
        if (!playBtn || !video) return;

        /* ── Play ── */
        playBtn.addEventListener('click', function () {
          /* Stop every other playing video in this section first */
          section.querySelectorAll('[data-vtc-media]').forEach(function (otherMedia) {
            if (otherMedia === media) return;
            var otherVideo = otherMedia.querySelector('.vtc-video');
            if (otherVideo) {
              otherVideo.pause();
              otherVideo.currentTime = 0;
            }
            otherMedia.classList.remove('is-playing');
          });

          /* Play this video — no native controls */
          media.classList.add('is-playing');
          video.removeAttribute('controls');
          video.play();
        });

        /* ── Pause button click ── */
        if (pauseBtn) {
          pauseBtn.addEventListener('click', function () {
            video.pause();
            /* The pause event listener below handles restoring the card */
          });
        }

        /* ── Video paused (via pause button or any other means) ── */
        video.addEventListener('pause', function () {
          setTimeout(function () {
            if (video.paused && !video.ended) {
              media.classList.remove('is-playing');
              video.currentTime = 0;
            }
          }, 300);
        });

        /* ── Video ended ── */
        video.addEventListener('ended', function () {
          media.classList.remove('is-playing');
          video.currentTime = 0;
        });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('.video-testimonials').forEach(function (section) {
        if (section.dataset.vtcInitialized) return;
        section.dataset.vtcInitialized = 'true';
        initCarousel(section);
        initPlayButtons(section);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
